// src/pages/financeiro/FinanceiroHomePage.jsx
import React, { useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import LayoutDesktop from "../../layouts/LayoutDesktop";
import LayoutMobile from "../../layouts/LayoutMobile";
import { useIsMobile } from "../../hooks/useIsMobile";

export default function FinanceiroHomePage() {
  const { tema } = useTheme();
  const isMobile = useIsMobile(900);
  const [sidebarAberta, setSidebarAberta] = useState(false);

  const conteudo = (
    <section className="pc-card">
      <h2 style={{ marginTop: 0 }}>Financeiro</h2>
      <p style={{ marginTop: 8, lineHeight: 1.5 }}>
        Modulo separado da Manutencao para evoluir sem risco. O MVP financeiro agora inclui:
        <strong> contas</strong>, <strong>cartoes de credito</strong>, <strong>contas a pagar</strong>,
        <strong> receitas</strong> e <strong>lancamentos</strong>.
      </p>
      <ul style={{ marginTop: 10, lineHeight: 1.6 }}>
        <li>Cadastros: Contas e Cartões</li>
        <li>Movimentação: Receitas e Contas a Pagar</li>
        <li>Consolidação: Lançamentos</li>
      </ul>
      <div style={{ marginTop: 12, fontSize: 13, opacity: 0.9 }}>
        Use o menu lateral em <strong>Financeiro</strong> para acessar as telas.
      </div>
    </section>
  );

  if (isMobile) {
    return (
      <LayoutMobile
        tema={tema}
        titulo="Financeiro"
        sidebarAberta={sidebarAberta}
        onToggleSidebar={() => setSidebarAberta((prev) => !prev)}
      >
        {conteudo}
      </LayoutMobile>
    );
  }

  return (
    <LayoutDesktop tema={tema} titulo="Financeiro" subtitulo="Modulo em implantacao (MVP)">
      {conteudo}
    </LayoutDesktop>
  );
}
